module.exports = __webpack_public_path__ + "img/emo_26.8621f660.gif";